import { ApolloQueryResult } from '@apollo/client';
import { Box, Button, Icon } from '@bechtel/gds';
import { FC, PropsWithChildren } from 'react';
import { MultiLingualText } from '~/components';
//@ts-ignore images ignore
import { ReactComponent as ErrorRetryIcon } from '~/images/error-retry.svg';

interface ErrorRetryProps {
  refetch: (variables?: Record<string, any> | undefined) => Promise<ApolloQueryResult<any>>;
}

export const ErrorRetry: FC<PropsWithChildren<ErrorRetryProps>> = ({ refetch }) => {
  return (
    <Box
      alignItems={{ sm: 'center' }}
      justifyContent={{ sm: 'center' }}
      flexGrow={{ sm: 1 }}
      flexDirection={{ sm: 'column' }}
      p={{ sm: '500' }}
    >
      <Box alignItems={{ sm: 'center' }} justifyContent={{ sm: 'center' }}>
        <ErrorRetryIcon />
      </Box>
      <Box mt={{ sm: '500' }}>
        <MultiLingualText size="500" weight="600">
          Error loading data from the server.
        </MultiLingualText>
      </Box>
      <Box mt={{ sm: '300' }} mb={{ sm: '550' }}>
        <MultiLingualText color="grey.500" size="400">
          Please try again later.
        </MultiLingualText>
      </Box>
      <Button onClick={() => refetch()} style={{ width: '90px' }}>
        <Box mr={{ sm: '400' }}>
          <Icon icon="arrows-rotate" iconStyle="regular" />
        </Box>
        <MultiLingualText>Retry</MultiLingualText>
      </Button>
    </Box>
  );
};
